import "./css/Personalized.css"

const Personalized = () => {
	return (
		<div className="personalized-container">
			<p className="personalize-upgrade">
				UPGRADE YOUR BUSINESS TO NEXT LEVEL
			</p>
			<p className="personalized-desc">
				Using AI voice/text based Meow generation systems to
				understand the real intent of your customers and validate them
				automatically and enable the contact center agents to act
				swiftly with proper and personalized solutions
			</p>
			<button className="personalized-button">
				GET A PERSONALIZED DEMO
			</button>
		</div>
	)
}

export default Personalized